import { Component, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RECOMMEND_ICON } from 'src/app/data/constants/Data';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() type: string = 'basic';
  @Input() name: string = '';
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  @Input() clickFunction: (args: any) => void = () => { };
  @Input() saveFunction: (args: any) => void = () => { };
  @Input() someArgs: any = '';
  @Input() size: string = 'medium';
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
    this.iconRegistry.addSvgIconLiteral('recommend', this.sanitizer.bypassSecurityTrustHtml(RECOMMEND_ICON));
  }
  functionInvoker(): void {
    console.log('sup1212');
    this.clickFunction(this.someArgs);
  }
}
